import script from "./balance_enquiry.vue?vue&type=script&lang=ts&setup=true"
export * from "./balance_enquiry.vue?vue&type=script&lang=ts&setup=true"

import "./balance_enquiry.vue?vue&type=style&index=0&id=5cc1977f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc1977f"]])

export default __exports__